<div [class]="cardClasses()" (click)="handleClick()">
  <ng-content></ng-content>
</div>
